// Module
var code = "<p><a href=\"introduction/committee\">Члены Комитета</a> могут предлагать изменения динамических параметров блокчейна, таких как комиссия, время блока и многое другое. Эта позиция несет в себе большую ответственность, которая требует четкого понимания механизма работы BitShares.</p> ";
// Exports
export default code;